import { render } from "./TextBrowseWithUnitItem.vue?vue&type=template&id=1d0a5210"
import script from "./TextBrowseWithUnitItem.vue?vue&type=script&lang=js"
export * from "./TextBrowseWithUnitItem.vue?vue&type=script&lang=js"
script.render = render

export default script